import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/

export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <path d="M12 21l-.833-.76a165.365 165.365 0 0 1-4.5-4.317c-1.186-1.19-2.125-2.24-2.82-3.15-.694-.91-1.176-1.734-1.445-2.475A6.522 6.522 0 0 1 2 8.062c0-1.424.481-2.624 1.444-3.6C4.407 3.489 5.593 3 7 3a5.29 5.29 0 0 1 2.75.76c.852.506 1.602 1.246 2.25 2.221.648-.975 1.398-1.715 2.25-2.222A5.29 5.29 0 0 1 17 3c1.407 0 2.593.487 3.556 1.463.962.974 1.444 2.175 1.444 3.6 0 .75-.134 1.495-.402 2.235-.27.74-.75 1.566-1.445 2.475-.694.91-1.63 1.96-2.806 3.15-1.176 1.19-2.68 2.63-4.514 4.318L12 21z" />
    </Icons>
  );
}
